module.exports = __webpack_public_path__ + "static/google-search-logo-77634ba9abf748f21f7c02c84d5da113.png";